import { render, staticRenderFns } from "./ShopperPersonas.vue?vue&type=template&id=d9ba95a6&scoped=true&"
import script from "./ShopperPersonas.vue?vue&type=script&lang=js&"
export * from "./ShopperPersonas.vue?vue&type=script&lang=js&"
import style0 from "./ShopperPersonas.vue?vue&type=style&index=0&id=d9ba95a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ba95a6",
  null
  
)

export default component.exports